// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3nVra","error":"Textarea_error__21t3N","readonly":"Textarea_readonly__fZQaa","disabled":"Textarea_disabled__11URK"};